@if (header) {
  <h1 mat-dialog-title>{{ header }}</h1>
}
<mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Dostępne czcionki"
      ><lib-list-loader [obs]="fonts$">
      @for (font of localFontList; track font) {
        <div
          (click)="picked.emit(font)"
          class="font"
          [ngStyle]="{
            fontFamily: font.fontId
          }"
          >
          {{ font.name }}
        </div>
      }
    </lib-list-loader>
  </mat-tab>
  <mat-tab label="Moje czcionki">
    <div class="content">
      <lib-button lg
        ><input
        #upload
        (change)="pickedFile()"
        type="file"
        accept=".ttf, .otf, .woff, .woff2"
        />Wgraj nową czcionkę
      </lib-button>
      <lib-list-loader [obs]="fonts$">
        @for (font of fonts$ | async; track font) {
          <div
            (click)="picked.emit(font)"
            class="font"
            [ngStyle]="{
              fontFamily: font.fontId
            }"
            >
            {{ font.name }}
          </div>
        }
      </lib-list-loader>
    </div>
  </mat-tab>
</mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <lib-button mat-dialog-close>Zamknij</lib-button>
</mat-dialog-actions>
